<div class="container" [hidden]="(breadcrumb$ | async)?.hidden">
  <div class="app-breadcrumb row">
    <div class="col">
      <a [routerLink]="(breadcrumb$ | async)?.url">{{(breadcrumb$ | async)?.text}}</a>
    </div>
  </div>
</div>  